unit View.Versoes.Edit;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls,

  Bcl.Rtti.Common, XData.Web.Client, Data.DB, WEBLib.CDS,
  WEBLib.DBCtrls, XData.Web.JsonDataset, XData.Web.Dataset, JS,

  App.Types, Crud.Utils, WEBLib.DB, WEBLib.Controls, WEBLib.ExtCtrls,
  UHelperServer, UUtils, UWeb.Enum;

type
  TFViewVersoesEdit = class(TForm)
    DataSource: TDatasource;
    btCancel: TButton;
    btSave: TButton;
    btDelete: TButton;
    lbid: TLabel;
    edid: TDBEdit;
    lbnome: TLabel;
    ednome: TDBEdit;
    lbinclusao: TLabel;
    edinclusao: TDBEdit;
    lbalteracao: TLabel;
    edalteracao: TDBEdit;
    XDataClientVersoesGet: TXDataWebClient;
    XDataClientVersoesDelete: TXDataWebClient;
    VersoesDataset: TXDataWebDataSet;
    VersoesDatasetid: TIntegerField;
    VersoesDatasetnome: TStringField;
    VersoesDatasetinclusao: TDateTimeField;
    VersoesDatasetalteracao: TDateTimeField;
    procedure btCloseMessageClick(Sender: TObject);
    procedure btCancelClick(Sender: TObject);
    procedure btSaveClick(Sender: TObject);
    [async]
    procedure btDeleteClick(Sender: TObject); async;
    procedure XDataClientVersoesGetLoad(Response: TXDataClientResponse);
    procedure XDataClientVersoesDeleteLoad(Response: TXDataClientResponse);
    procedure XDataClientVersoesDeleteError(Error: TXDataClientError);
    procedure VersoesDatasetAfterApplyUpdates(Sender: TDataSet;
      Info: TResolveResults);
    procedure WebFormCreate(Sender: TObject);
    procedure WebFormShow(Sender: TObject);
    procedure ednomeClick(Sender: TObject);
    procedure ednomeKeyPress(Sender: TObject; var Key: Char);
  private
    FId: JSValue;
    FShowListProc: TListProc;
    procedure InsertEntity;
    procedure LoadEntity;
    procedure ShowNotification(Notification: string);
    procedure HiddenNotification;
    class function InternalCreateForm(AElementID: string;
      AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm; overload;
  protected
    FInserting: Boolean;
  public
    class function CreateForm(AElementID: string;
      AShowListProc: TListProc; AId: JSValue): TForm; overload;
  protected procedure LoadDFMValues; override; end;

var
  FViewVersoesEdit: TFViewVersoesEdit;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewVersoesEdit }

procedure TFViewVersoesEdit.btSaveClick(Sender: TObject);
begin
  TUtils.LimparErrosClass;

  if Trim(ednome.Text) =  '' then
  begin
    TUtils.SetErroClass('view_versoes_form_lbnome', 'Informe o nome da versão!');

    Exit;
  end;

  if VersoesDataset.State in dsEditModes then
  begin
    VersoesDataset.Post;
    VersoesDataset.ApplyUpdates;
  end
  else
    FShowListProc;
end;

procedure TFViewVersoesEdit.btDeleteClick(Sender: TObject);
begin
  if Await(TUtils.ChamarMensagemDialog(TTipoDialogo.CONFIRMACAO, 'Tem certeza que deseja '+
    'excluir essa versão?')) then
  begin
    if VersoesDataset.State in dsEditModes then
      VersoesDataset.Post;

    XDataClientVersoesDelete.Delete(VersoesDataset.EntitySetName, TJSObject(VersoesDataset.CurrentData));
  end;
end;


class function TFViewVersoesEdit.CreateForm(AElementID: string;
  AShowListProc: TListProc; AId: JSValue): TForm;
var
  Inserting: Boolean;
begin
  Inserting := isNull(AId);
  Result := InternalCreateForm(AElementID, AShowListProc, Inserting, AId);
end;

procedure TFViewVersoesEdit.ednomeClick(Sender: TObject);
begin
  TUtils.RemoverErroClass('view_versoes_form_lbnome');
end;

procedure TFViewVersoesEdit.ednomeKeyPress(Sender: TObject; var Key: Char);
begin
  if not(key in ['0'..'9', '.']) Then
    key := #0;
end;

procedure TFViewVersoesEdit.HiddenNotification;
begin
  //
end;

procedure TFViewVersoesEdit.InsertEntity;
begin
  VersoesDataset.Close;
  VersoesDataset.SetJsonData('{}');
  VersoesDataset.Open;
  VersoesDataset.Insert;
end;

class function TFViewVersoesEdit.InternalCreateForm(AElementID: string;
  AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewVersoesEdit(AForm).FInserting := AInserting;
    TFViewVersoesEdit(AForm).FId := AId;
    TFViewVersoesEdit(AForm).FShowListProc := AShowListProc;
    if AInserting then
      TFViewVersoesEdit(AForm).InsertEntity
    else
      TFViewVersoesEdit(AForm).LoadEntity;
    TFViewVersoesEdit(AForm).btDelete.Enabled := not AInserting;
  end;

begin
  Application.CreateForm(TFViewVersoesEdit, AElementID, Result, @AfterCreate);
end;

procedure TFViewVersoesEdit.LoadEntity;
var
  QueryString: string;
begin
  QueryString := TCrudUtils.GetEntityGetQueryString(
    VersoesDataset.Connection.Model.DefaultSchema.FindEntityType(
      VersoesDataset.EntitySetName
    )
  );
  XDataClientVersoesGet.Get(VersoesDataset.EntitySetName, QueryString, FId);
end;

procedure TFViewVersoesEdit.ShowNotification(Notification: string);
begin
  TUtils.ChamarMensagemDialog(TTipoDialogo.ERROR, Notification);
end;

procedure TFViewVersoesEdit.btCloseMessageClick(Sender: TObject);
begin
  HiddenNotification;
end;

procedure TFViewVersoesEdit.WebFormCreate(Sender: TObject);
begin
  HiddenNotification;
end;

procedure TFViewVersoesEdit.WebFormShow(Sender: TObject);
begin
  if FInserting then
  begin
    THelperServer.RemoverElementoPorId('div_inclusao');
    THelperServer.RemoverElementoPorId('div_alteracao');
    THelperServer.RemoverElementoPorId(btDelete.ElementID);

    if ednome.CanFocus then
      ednome.SetFocus;
  end
  else
  begin
    if not TUtils.PossuiPermissao(VersoesDataset.EntitySetName.ToLower, TTipoPermissao.ALTERAR) then
    begin
      ednome.Enabled := False;
      btSave.Enabled := False;
    end;

    if not TUtils.PossuiPermissao(VersoesDataset.EntitySetName.ToLower, TTipoPermissao.EXCLUIR) then
    begin
      btDelete.Enabled := False;
    end;
  end;
end;

procedure TFViewVersoesEdit.XDataClientVersoesGetLoad(Response: TXDataClientResponse);
begin
  VersoesDataset.Close;
  VersoesDataset.SetJsonData(Response.Result);
  VersoesDataset.Open;
  
  VersoesDataset.Edit;  
end;

procedure TFViewVersoesEdit.XDataClientVersoesDeleteError(
  Error: TXDataClientError);
begin
  ShowNotification(Error.ErrorMessage);
end;

procedure TFViewVersoesEdit.XDataClientVersoesDeleteLoad(
  Response: TXDataClientResponse);
begin
  FShowListProc;
end;

procedure TFViewVersoesEdit.VersoesDatasetAfterApplyUpdates(Sender: TDataSet;
  Info: TResolveResults);
var
  I: integer;
  ResolveInfo: TResolveInfo;
begin
  for I := 0 to Length(Info.Records) - 1 do
  begin
    ResolveInfo := Info.Records[I];

    if ResolveInfo.Error <> '' then
    begin
      if Pos('Duplicate entry', ResolveInfo.Error) > 0  then
        TUtils.SetErroClass('view_versoes_form_lbnome', 'Já existe alguma versão cadastrada com este nome!')
      else
        ShowNotification(ResolveInfo.Error);

      VersoesDataset.Edit;

      Exit;
    end;
  end;

  if FInserting then
    TUtils.ChamarMensagemDialog(TTipoDialogo.SUCESSO, 'Versão salva com sucesso!')
  else
    TUtils.ChamarMensagemDialog(TTipoDialogo.SUCESSO, 'Versão atualizada com sucesso!');

  FShowListProc;
end;

procedure TFViewVersoesEdit.btCancelClick(Sender: TObject);
begin
  FShowListProc;
end;

procedure TFViewVersoesEdit.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lbid := TLabel.Create('view.versoes.form.lbid');
  lbnome := TLabel.Create('view.versoes.form.lbnome');
  lbinclusao := TLabel.Create('view.versoes.form.lbinclusao');
  lbalteracao := TLabel.Create('view.versoes.form.lbalteracao');
  btCancel := TButton.Create('view.versoes.form.btBack');
  btSave := TButton.Create('view.versoes.form.btSave');
  btDelete := TButton.Create('view.versoes.form.btDelete');
  edid := TDBEdit.Create('view.versoes.form.edid');
  ednome := TDBEdit.Create('view.versoes.form.ednome');
  edinclusao := TDBEdit.Create('view.versoes.form.edinclusao');
  edalteracao := TDBEdit.Create('view.versoes.form.edalteracao');
  DataSource := TDataSource.Create(Self);
  VersoesDataset := TXDataWebDataSet.Create(Self);
  VersoesDatasetid := TIntegerField.Create(Self);
  VersoesDatasetnome := TStringField.Create(Self);
  VersoesDatasetinclusao := TDateTimeField.Create(Self);
  VersoesDatasetalteracao := TDateTimeField.Create(Self);
  XDataClientVersoesGet := TXDataWebClient.Create(Self);
  XDataClientVersoesDelete := TXDataWebClient.Create(Self);

  lbid.BeforeLoadDFMValues;
  lbnome.BeforeLoadDFMValues;
  lbinclusao.BeforeLoadDFMValues;
  lbalteracao.BeforeLoadDFMValues;
  btCancel.BeforeLoadDFMValues;
  btSave.BeforeLoadDFMValues;
  btDelete.BeforeLoadDFMValues;
  edid.BeforeLoadDFMValues;
  ednome.BeforeLoadDFMValues;
  edinclusao.BeforeLoadDFMValues;
  edalteracao.BeforeLoadDFMValues;
  DataSource.BeforeLoadDFMValues;
  VersoesDataset.BeforeLoadDFMValues;
  VersoesDatasetid.BeforeLoadDFMValues;
  VersoesDatasetnome.BeforeLoadDFMValues;
  VersoesDatasetinclusao.BeforeLoadDFMValues;
  VersoesDatasetalteracao.BeforeLoadDFMValues;
  XDataClientVersoesGet.BeforeLoadDFMValues;
  XDataClientVersoesDelete.BeforeLoadDFMValues;
  try
    Name := 'FViewVersoesEdit';
    Width := 593;
    Height := 373;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    SetEvent(Self, 'OnShow', 'WebFormShow');
    lbid.SetParentComponent(Self);
    lbid.Name := 'lbid';
    lbid.Left := 24;
    lbid.Top := 192;
    lbid.Width := 23;
    lbid.Height := 13;
    lbid.Caption := 'C'#243'd:';
    lbid.HeightPercent := 100.000000000000000000;
    lbid.WidthPercent := 100.000000000000000000;
    lbnome.SetParentComponent(Self);
    lbnome.Name := 'lbnome';
    lbnome.Left := 24;
    lbnome.Top := 219;
    lbnome.Width := 31;
    lbnome.Height := 13;
    lbnome.Caption := 'Nome:';
    lbnome.HeightPercent := 100.000000000000000000;
    lbnome.WidthPercent := 100.000000000000000000;
    lbinclusao.SetParentComponent(Self);
    lbinclusao.Name := 'lbinclusao';
    lbinclusao.Left := 24;
    lbinclusao.Top := 246;
    lbinclusao.Width := 44;
    lbinclusao.Height := 13;
    lbinclusao.Caption := 'Inclus'#227'o:';
    lbinclusao.HeightPercent := 100.000000000000000000;
    lbinclusao.WidthPercent := 100.000000000000000000;
    lbalteracao.SetParentComponent(Self);
    lbalteracao.Name := 'lbalteracao';
    lbalteracao.Left := 24;
    lbalteracao.Top := 273;
    lbalteracao.Width := 50;
    lbalteracao.Height := 13;
    lbalteracao.Caption := 'Altera'#231#227'o:';
    lbalteracao.HeightPercent := 100.000000000000000000;
    lbalteracao.WidthPercent := 100.000000000000000000;
    btCancel.SetParentComponent(Self);
    btCancel.Name := 'btCancel';
    btCancel.Left := 126;
    btCancel.Top := 313;
    btCancel.Width := 96;
    btCancel.Height := 25;
    btCancel.Caption := 'Cancel';
    btCancel.HeightPercent := 100.000000000000000000;
    btCancel.TabOrder := 1;
    btCancel.WidthPercent := 100.000000000000000000;
    SetEvent(btCancel, Self, 'OnClick', 'btCancelClick');
    btSave.SetParentComponent(Self);
    btSave.Name := 'btSave';
    btSave.Left := 24;
    btSave.Top := 313;
    btSave.Width := 96;
    btSave.Height := 25;
    btSave.Caption := 'Save';
    btSave.HeightPercent := 100.000000000000000000;
    btSave.TabOrder := 4;
    btSave.WidthPercent := 100.000000000000000000;
    SetEvent(btSave, Self, 'OnClick', 'btSaveClick');
    btDelete.SetParentComponent(Self);
    btDelete.Name := 'btDelete';
    btDelete.Left := 305;
    btDelete.Top := 313;
    btDelete.Width := 96;
    btDelete.Height := 25;
    btDelete.Caption := 'Delete';
    btDelete.HeightPercent := 100.000000000000000000;
    btDelete.TabOrder := 5;
    btDelete.WidthPercent := 100.000000000000000000;
    SetEvent(btDelete, Self, 'OnClick', 'btDeleteClick');
    edid.SetParentComponent(Self);
    edid.Name := 'edid';
    edid.Left := 221;
    edid.Top := 189;
    edid.Width := 200;
    edid.Height := 21;
    edid.Enabled := False;
    edid.HeightPercent := 100.000000000000000000;
    edid.TabOrder := 6;
    edid.Text := 'edid';
    edid.WidthPercent := 100.000000000000000000;
    edid.DataField := 'id';
    edid.DataSource := DataSource;
    ednome.SetParentComponent(Self);
    ednome.Name := 'ednome';
    ednome.Left := 221;
    ednome.Top := 216;
    ednome.Width := 200;
    ednome.Height := 21;
    ednome.HeightPercent := 100.000000000000000000;
    ednome.TabOrder := 7;
    ednome.Text := 'ednome';
    ednome.WidthPercent := 100.000000000000000000;
    SetEvent(ednome, Self, 'OnClick', 'ednomeClick');
    SetEvent(ednome, Self, 'OnKeyPress', 'ednomeKeyPress');
    ednome.DataField := 'nome';
    ednome.DataSource := DataSource;
    edinclusao.SetParentComponent(Self);
    edinclusao.Name := 'edinclusao';
    edinclusao.Left := 221;
    edinclusao.Top := 243;
    edinclusao.Width := 200;
    edinclusao.Height := 21;
    edinclusao.Enabled := False;
    edinclusao.HeightPercent := 100.000000000000000000;
    edinclusao.TabOrder := 8;
    edinclusao.Text := 'edinclusao';
    edinclusao.WidthPercent := 100.000000000000000000;
    edinclusao.DataField := 'inclusao';
    edinclusao.DataSource := DataSource;
    edalteracao.SetParentComponent(Self);
    edalteracao.Name := 'edalteracao';
    edalteracao.Left := 221;
    edalteracao.Top := 270;
    edalteracao.Width := 200;
    edalteracao.Height := 21;
    edalteracao.Enabled := False;
    edalteracao.HeightPercent := 100.000000000000000000;
    edalteracao.TabOrder := 9;
    edalteracao.Text := 'edalteracao';
    edalteracao.WidthPercent := 100.000000000000000000;
    edalteracao.DataField := 'alteracao';
    edalteracao.DataSource := DataSource;
    DataSource.SetParentComponent(Self);
    DataSource.Name := 'DataSource';
    DataSource.DataSet := VersoesDataset;
    DataSource.Left := 176;
    DataSource.Top := 56;
    VersoesDataset.SetParentComponent(Self);
    VersoesDataset.Name := 'VersoesDataset';
    VersoesDataset.AfterApplyUpdates := VersoesDatasetAfterApplyUpdates;
    VersoesDataset.EntitySetName := 'Versoes';
    VersoesDataset.Connection := DMConnection.ApiConnection;
    VersoesDataset.Left := 176;
    VersoesDataset.Top := 8;
    VersoesDatasetid.SetParentComponent(VersoesDataset);
    VersoesDatasetid.Name := 'VersoesDatasetid';
    VersoesDatasetid.FieldName := 'id';
    VersoesDatasetnome.SetParentComponent(VersoesDataset);
    VersoesDatasetnome.Name := 'VersoesDatasetnome';
    VersoesDatasetnome.FieldName := 'nome';
    VersoesDatasetnome.Required := True;
    VersoesDatasetnome.Size := 255;
    VersoesDatasetinclusao.SetParentComponent(VersoesDataset);
    VersoesDatasetinclusao.Name := 'VersoesDatasetinclusao';
    VersoesDatasetinclusao.FieldName := 'inclusao';
    VersoesDatasetinclusao.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    VersoesDatasetalteracao.SetParentComponent(VersoesDataset);
    VersoesDatasetalteracao.Name := 'VersoesDatasetalteracao';
    VersoesDatasetalteracao.FieldName := 'alteracao';
    VersoesDatasetalteracao.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    XDataClientVersoesGet.SetParentComponent(Self);
    XDataClientVersoesGet.Name := 'XDataClientVersoesGet';
    XDataClientVersoesGet.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientVersoesGet, Self, 'OnLoad', 'XDataClientVersoesGetLoad');
    XDataClientVersoesGet.Left := 64;
    XDataClientVersoesGet.Top := 8;
    XDataClientVersoesDelete.SetParentComponent(Self);
    XDataClientVersoesDelete.Name := 'XDataClientVersoesDelete';
    XDataClientVersoesDelete.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientVersoesDelete, Self, 'OnLoad', 'XDataClientVersoesDeleteLoad');
    SetEvent(XDataClientVersoesDelete, Self, 'OnError', 'XDataClientVersoesDeleteError');
    XDataClientVersoesDelete.Left := 64;
    XDataClientVersoesDelete.Top := 56;
  finally
    lbid.AfterLoadDFMValues;
    lbnome.AfterLoadDFMValues;
    lbinclusao.AfterLoadDFMValues;
    lbalteracao.AfterLoadDFMValues;
    btCancel.AfterLoadDFMValues;
    btSave.AfterLoadDFMValues;
    btDelete.AfterLoadDFMValues;
    edid.AfterLoadDFMValues;
    ednome.AfterLoadDFMValues;
    edinclusao.AfterLoadDFMValues;
    edalteracao.AfterLoadDFMValues;
    DataSource.AfterLoadDFMValues;
    VersoesDataset.AfterLoadDFMValues;
    VersoesDatasetid.AfterLoadDFMValues;
    VersoesDatasetnome.AfterLoadDFMValues;
    VersoesDatasetinclusao.AfterLoadDFMValues;
    VersoesDatasetalteracao.AfterLoadDFMValues;
    XDataClientVersoesGet.AfterLoadDFMValues;
    XDataClientVersoesDelete.AfterLoadDFMValues;
  end;
end;

end.
